import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_CORGI_USE_ASSETS_DOMAIN_FOR_SCRIPTS = createFcmConfig('corgi_use_assets_domain_for_scripts', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
